import * as React from "react";
import {
    Code as CodeIcon,
    Email as EmailIcon,
    GitHub as GitHubIcon,
    LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
import {
    Box,
    Container,
    Divider,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";

interface SocialLink {
  name: string;
  icon: React.ReactNode;
  url: string;
}

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const socialLinks: SocialLink[] = [
    {
      name: "GitHub",
      icon: <GitHubIcon />,
      url: "https://github.com/duyguevrim",
    },
    {
      name: "LinkedIn",
      icon: <LinkedInIcon />,
      url: "https://linkedin.com/in/duyguevrimodabas",
    },
    {
      name: "Email",
      icon: <EmailIcon />,
      url: "mailto:duyguevrimodabass@gmail.com",
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
       
        // backgroundColor: theme.palette.mode === 'light'
        //   ? theme.palette.grey[100]
        //   : theme.palette.grey[900],
      }}
    >
      <Container maxWidth="sm">
        <Divider sx={{ mb: 3 }} />

        <Stack direction="column" alignItems="center" spacing={2}>
          <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            {socialLinks.map((link) => (
              <Tooltip key={link.name} title={link.name}>
                <IconButton
                  aria-label={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    transition: "transform 0.2s",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  {link.icon}
                </IconButton>
              </Tooltip>
            ))}
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <CodeIcon fontSize="small" />
            <Typography variant="body2" color="text.secondary" align="center">
              Designed & Built by Duygu Evrim Odabas
            </Typography>
            <CodeIcon fontSize="small" />
          </Stack>

          <Typography variant="caption" color="text.secondary" align="center">
            © {currentYear} All rights reserved
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
